import { apiSlice } from '../../../../app/services/apiSlice';

const CHECK = 'checks';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllQuestions: builder.mutation({
      query: (params) => ({
        url: `${CHECK}/question-profiles`,
        params,
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.questionsList?.map((account) => ({
          ...account,
          value: account?.id,
          title: `${account?.name}`,
        }));
        responseData.total = responseData?.totalCount;
        responseData.page = responseData.currentPage;
        return responseData || {};
      },
    }),

     getAllQuestion: builder.mutation({
      query: (params) => ({
        url: `${CHECK}/reference-linked-forms`,
        params,
      }),
      transformResponse: (responseData) => {  
        responseData.options = responseData?.data?.backgroundForms?.map((account) => ({
          ...account,
          value: account?.id,
          title: `${account?.referenceForm?.title}`,
        }));
        responseData.total = responseData?.data?.total;
        responseData.page = responseData.data?.page;
        return responseData || {};
      },
    }),

    // getReferenceChecksCredits: builder.query({
    //     query: () => ({
    //         url: `${CHECK}/refs-left`,
    //     }),
    // }),
     getOldReferenceCheckDetails: builder.query({
      query: (id) => ({
        url: `applications/${id}/references`,
      }),
    }),
    getReferenceCheckDetails: builder.query({
      query: (params) => ({
        url: `ref-check/timeline`,
        params,
      }),
    }),
    // updatePosition: builder.mutation({
    //   query: (params) => ({
    //     url: `${JOB_URL}${params.jobId}/position/${params.id}`,
    //     method: 'PUT',
    //     body: params.params,
    //   }),
    // }),

    getProductAmount: builder.query({
      query: (id) => ({
        url: `products?accessKey=IN_HOUSE_REF_CHECK`,
      }),
    }),

    referenceCheckSubmit: builder.mutation({
      query: (params) => ({
        url: `${CHECK}/reference/send`,
        method: 'POST',
        body: params,   
      }),
    }),

       sendReminder: builder.mutation({
      query: (params) => ({
        url: `${CHECK}/reference/reminder`,
        method: 'POST',
        body: params,   
      }),
    }),

    getBgCheck: builder.query({
      query: () => ({
        url: `${CHECK}/`,
      }),
    }),

    securitasBgCheck: builder.mutation({
      query: (params) => ({
        url: `${CHECK}/background`,
        method: 'POST',
        body: params,
      }),
    }),

    getBackgroundCheckData: builder.query({
      query: (id) => ({
        url: `${CHECK}/${id}`,
      }),
    }),
  }),
});

export const {
  useGetBgCheckQuery,
  useGetAllQuestionsMutation,
  useGetAllQuestionMutation,
  // useGetReferenceChecksCreditsQuery,
  useReferenceCheckSubmitMutation,
  useGetOldReferenceCheckDetailsQuery,
  useSendReminderMutation,
  useGetReferenceCheckDetailsQuery,
  useGetProductAmountQuery,
  useSecuritasBgCheckMutation,
  useGetBackgroundCheckDataQuery
} = extendedApiSlice;
